module.exports = __webpack_public_path__ + "static/media/default.2fc073f9.jpg";